import { func, node, oneOfType, shape, string } from 'prop-types'

import IconCaretLeft from 'views/components/atoms/Icon/IconCaretLeft'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import OffCanvasNewHeader from 'views/components/organisms/OffCanvasNew/OffCanvasNewHeader'

const OffCanvasNewScreen = ({
  children,
  onMenuClose,
  headerInfo,
  onGoBack,
  backButtonText,
  style,
  dataQaId,
}) => {
  return (
    <div
      id="OffCanvasHomeScreen"
      aria-labelledby="OffCanvasMenuHeader"
      data-clientside-hook="menu"
      className="o-OffCanvasNewView"
      style={style}
    >
      <OffCanvasNewHeader
        onMenuClose={onMenuClose}
        headerInfo={headerInfo}
        onGoBack={onGoBack}
        backButtonText={backButtonText}
        dataQaId={dataQaId}
      />
      <div className="u-overflow">
        {onGoBack && (
          <ButtonTransparent
            name="go-back-navigation"
            onClick={onGoBack}
            alternative
            className="o-OffCanvasNewView__back-button"
          >
            <IconCaretLeft />
            <span className="o-OffCanvasNewView__back-button-text">
              {backButtonText}
            </span>
          </ButtonTransparent>
        )}
        {children}
      </div>
    </div>
  )
}

OffCanvasNewScreen.propTypes = {
  children: node,
  onMenuClose: func,
  headerInfo: node,
  onGoBack: func,
  backButtonText: oneOfType([string, node]),
  dataQaId: string,
  style: shape({}),
}

export default OffCanvasNewScreen
